import { render, staticRenderFns } from "./Contrassenha.vue?vue&type=template&id=16267ee3&scoped=true&"
import script from "./Contrassenha.vue?vue&type=script&lang=js&"
export * from "./Contrassenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16267ee3",
  null
  
)

export default component.exports